var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg30(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.576 29.591c.8.304 1.107 1.488 1.168 2.005.124.942-.152 1.307-.46 1.307-.308 0-.739-.365-1.199-1.094-.462-.73-.646-1.55-.4-1.975.154-.274.49-.395.891-.243Zm-4.672 3.434c.492 0 1.045.212 1.537.637.953.79 1.23 1.701.738 2.37-.277.334-.738.547-1.26.547-.523 0-1.076-.182-1.444-.517-.861-.729-1.107-1.945-.555-2.613.216-.273.554-.424.984-.424Zm-10.757 8.78C10.467 41.804 1 32.446 1 20.901 1 9.357 10.467 0 22.146 0c11.68 0 21.148 9.358 21.148 20.902 0 3.918-1.107 7.596-2.981 10.725-.062.09-.216.06-.246-.061-.738-5.134-3.904-7.96-8.514-8.81-.4-.062-.462-.305.06-.365 1.415-.122 3.412-.092 4.457.09.062-.516.093-1.063.093-1.61 0-7.625-6.27-13.824-13.986-13.824-7.714 0-13.985 6.199-13.985 13.825 0 7.626 6.27 13.824 13.986 13.824h.645a18.438 18.438 0 0 1-.277-3.738c.031-.85.216-.972.584-.304 1.937 3.312 4.704 6.29 10.113 7.474 4.426.973 8.852 2.097 13.616 8.081.43.517-.215 1.064-.707.639-4.856-4.254-9.282-5.652-13.309-5.652-4.519.032-7.59.608-10.696.608Z",
    fill: "#FF8C00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg30);
export default __webpack_public_path__ + "static/media/30.75479360845373f5c916a29d024802dc.svg";
export { ForwardRef as ReactComponent };